const doc = [({"ja":({"adminConstantUserType":({"company":"{{company}}専用会員", "common":"公式サイトグループ会員"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;